export const deepCopy = (obj) => obj && JSON.parse(JSON.stringify(obj));
